import Header from '../components/Header';
import Footer from '../components/Footer';
import { Tractor, Clipboard, Globe, ShoppingCart } from 'lucide-react';
import HeroSection from '../components/HeroSection';
import ServiceSection from '../components/ServicesSection';
import Service2 from '../components/Services2';


const Home = () => {
  return (
    <div className="home" style={{ margin: 0, padding: 0 }}>
      
        <link rel="canonical" href="https://www.zaoafrika.co.ke/" />
        <title>Zao Afrika | Empowering Farmers, Growing Futures</title>
        <meta
          name="description"
          content="Zao Afrika empowers farmers through organic farming, value addition, and access to premium markets."
        />
      
      <Header />
      <main className="main" style={{ margin: 0, padding: 0 }}>
        {/* Hero Section */}
        <section id="hero" style={{ margin: 0, padding: 0 }}>
          <HeroSection />
        </section>
        {/* End Hero Section */}

        {/* Services Section */}
        <section id="services" className="services section" style={{ paddingBottom: '1rem' }}>
          <ServiceSection />
        </section>
        {/* End Services Section */}

        {/* About Section */}
          <section className="about" style={{ paddingTop: '1rem', paddingBottom: '0' }}>
            <div className="content">
              <div className="container">
                <div className="row">
            <div className="col-lg-6 mb-3">
              <img 
                src="/assets/img/23.jpg" 
                alt="Zao Afrika Chia Seeds" 
                className="img-fluid img-overlap" 
                data-aos="zoom-out" 
              />
            </div>
            <div className="col-lg-5 ml-auto" data-aos="fade-up" data-aos-delay={100}>
              <h3 className="content-subtitle text-white opacity-50">What We Do</h3>
              <h2 
                className="content-title mb-3"
                style={{ textAlign: 'center' }}
              >
                <strong>Organic Farming & Value Chain Addition</strong> 
              </h2>
              <p className="opacity-50" style={{ textAlign: 'left' }}>
               We drive sustainable production of organic food and value addition, while enhancing access to premium markets through innovation, technology, and financial inclusion. Our main services include:
              </p>
              <div className="row my-3">
                <div className="col-lg-12 d-flex align-items-start mb-3">
                  <Tractor className="me-4 display-6" size={48} />
                  <div>
              <h4 className="m-0 h5 text-white">Contract Farming Agreements</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>Secure structured contracts, access quality inputs, and harvest with confidence knowing your buyer, price, and expected earnings in advance!</p>
                  </div>
                </div>
                <div className="col-lg-12 d-flex align-items-start mb-3">
                  <Clipboard className="me-4 display-6" size={44}/>
                  <div>
              <h4 className="m-0 h5 text-white">Harvest Purchase Agreements</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>Not in a contract but still looking for a reliable buyer? We buy directly from farmers at competitive market prices.</p>
                  </div>
                </div>
                
                <div className="col-lg-12 d-flex align-items-start mb-3">
                  <ShoppingCart className="me-4 display-6" size={56}/>
                  <div>
              <h4 className="m-0 h5 text-white">Logistics & Aggregation</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>We provide threshing, cleaning, dehusking, sorting, packaging, transportation and logistics of bulk farm produce.</p>
                  </div>
                </div>
                <div className="col-lg-12 d-flex align-items-start">
                  <Globe className="me-4 display-6" size={40}/>
                  <div>
              <h4 className="m-0 h5 text-white">Agri-Tech Solutions</h4>
              <p className="text-white opacity-50" style={{ textAlign: 'left' }}>We provide real-time farmer support through emerging technologies including AI.</p>
                  </div>
                </div>
              </div>
            </div>
                </div>
              </div>
            </div>
          </section>
          {/* End About Section */}

       { /* About 3 Section */}
          <section id="about-3" className="about-3 section" style={{ padding: '0rem 0' }}>
            <div className="container" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
              <div className="section-title" data-aos="fade-up" style={{ marginBottom: '0.0rem', paddingTop: 0 }}>
                <h3 className="content-subtitle text-green opacity-75">Our Mission and Vision</h3>
                <h2 
                className="content-title mb-3"
                style={{ textAlign: 'center' }}
              >Driving Sustainable Growth, Empowering Farmers</h2>
              </div>
              <div className="row gy-3 justify-content-between align-items-center">
                <div className="col-lg-6 order-lg-2 position-relative" data-aos="zoom-out">
            <img 
              src="/assets/img/Website media/Zao1.png" 
              alt="Plants make life better" 
              className="img-fluid" 
            />
            <a href="https://youtu.be/g_1XUcQSbWE?si=5A8oWB78xVgpUrOE" className="glightbox pulsating-play-btn">
              <span className="play"><i className="bi bi-play-fill" /></span>
            </a>
                </div>
                <div className="col-lg-5 order-lg-1" data-aos="fade-up" data-aos-delay={100}>
            <h4 className="mb-2" style={{ fontSize: '30px', color: 'green' }}>Mission</h4>
            <p className="mb-3" style={{ fontSize: '22px' }}>
            To drive sustainable agricultural growth by enabling farmers to produce, add value, and access premium markets through innovation, financial inclusion, and technology. At Zao Afrika, we focus on maximizing profitability and delivering strong returns for farmers and investors alike.
            </p>
            <h4 className="mb-2" style={{ fontSize: '30px', color: 'green' }}>Vision</h4>
            <p className="mb-3" style={{ fontSize: '22px' }}>
            To become Africa's leading platform for sustainable superfood production, empowering farmers and delivering premium, profitable agricultural products to global markets through innovation, technology, and value addition.
            </p>
           
                </div>
              </div>
            </div>
          </section>
          {/* End About 3 Section */}

        {/* Services 2 Section */}
        <section id="services-2" className="services-2 section dark-background" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
          <Service2 />
        </section>
        {/* End Services 2 Section */}

        {/* Testimonials Section 
        <section className="testimonials-12 testimonials section" id="testimonials" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
          <div className="container section-title" data-aos="fade-up">
            <h2>TESTIMONIALS</h2>
            <p>Empowering Farmers, Expanding Markets</p>
          </div>
          <div className="testimonial-wrap">
            <div className="container">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="testimonial">
                    <img 
                      src="/assets/img/testimonials/Farmer 3.png" 
                      alt="Esther Achieng' - Testimonial author" 
                    />
                    <blockquote>
                      <p>
                      "Before Zao Afrika, selling my chia seeds was a struggle. Now, I earn more than I did with maize and beans."
                      </p>
                    </blockquote>
                    <p className="client-name">Eshter Achieng'</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="testimonial">
                    <img 
                      src="/assets/img/testimonials/Farmer 2.png" 
                      alt="Joseph Mwangi' - Testimonial author" 
                    />
                    <blockquote>
                      <p>
                      "I never thought avocado farming could be this profitable. Since I joined Zao Afrika, I don't have to worry about the market for my harvest."
                      </p>
                    </blockquote>
                    <p className="client-name">Joseph Mwangi</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="testimonial">
                    <img 
                      src="/assets/img/testimonials/Farmer 4.png" 
                      alt="Regina Chepkemboi - Testimonial author" 
                    />
                    <blockquote>
                      <p>
                      "I used to grow sukuma wiki and onions, but the returns were too low. Thanks to Zao Afrika, switching to quinoa has really changed my life."
                      </p>
                    </blockquote>
                    <p className="client-name">Regina Chepkemboi</p>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="testimonial">
                    <img 
                      src="/assets/img/testimonials/Farmer 1.png" 
                      alt="Wycliffe Ambani - Testimonial author" 
                    />
                    <blockquote>
                      <p>
                      "With Zao Afrika, I can easily thresh and clean my flax seeds harvest at an affordable price, without any wastage."
                      </p>
                    </blockquote>
                    <p className="client-name">Wycliffe Ambani</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        */}
        {/* End Testimonials Section */}

        {/* Recent Posts Section */}
        
        {/* End Recent Posts Section */}

        {/* Call To Action Section */}
        <section id="call-to-action" className="call-to-action section light-background" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
          <div className="content">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h3>Subscribe To Our Newsletter</h3>
                  <p className="opacity-50">
                  Join the Zao Afrika community and get the latest updates on market opportunities, farming tips, success stories, and value addition insights straight to your inbox.
                  </p>
                </div>
                <div className="col-lg-6">
                  <form action="forms/newsletter.php" className="form-subscribe php-email-form">
                    <div className="form-group d-flex align-items-stretch">
                      <input 
                        type="email" 
                        name="email" 
                        className="form-control h-100" 
                        placeholder="Enter your e-mail" 
                      />
                      <input 
                        type="submit" 
                        className="btn btn-secondary px-4" 
                        defaultValue="Subscribe" 
                      />
                    </div>
                    <div className="loading">Loading</div>
                    <div className="error-message" />
                    <div className="sent-message">
                      Your subscription request has been sent. Thank you!
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Call To Action Section */}
      </main>
      <Footer />
    </div>
  );
};

export default Home;